import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VinLookupRoutingModule } from './vin-lookup-routing.module';
import { VinLookupComponent } from './vin-lookup.component';
import { SharedModule } from '../../shared/shared.module';


@NgModule({
  declarations: [
    VinLookupComponent
  ],
  imports: [
    CommonModule,
    VinLookupRoutingModule,
    SharedModule
  ]
})
export class VinLookupModule { }
